import { encode as base64_encode } from 'base-64';
import { postApi } from '../components/Utility'
import {
 action,

 makeObservable,
 observable,

} from 'mobx';
import config from "../config";


class ForgetPassStore {
 jobTypeList = []
 jobList = []
 total = 0
 loading = false
 rootStore

 constructor(rootStore) {
   makeObservable(this, {
     jobTypeList: observable,
     total: observable,
     jobList: observable,
     loading: observable,

     forgetPass: action,
     // getJobTypeData:action,
     // getJobData:action

   });
   this.rootStore = rootStore;

 }

 async forgetPass(values) {
   console.log(values)
   var postData = values;
   var response;     
   if(config.pythonReport === 1){
     response = await postApi
           .getClient()
           .post(config.NodeUrl + "/users/sendForgetPasswordEmail",postData);
   } else{
     const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=user&a=forgotPass", "postData=" + base64Input);
   }
  
   return response
 }






}

export default ForgetPassStore;